const local = {
  API_ROOT: 'https://local-api.avatarnutrition.com',
  BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
  FRESHCHAT: 'bb531a73-bcce-4810-afac-6e85213992cb',
  HOME_ROOT: 'http://localhost:3000',
  SCANDIT_KEY: "AbSTCxJ+NMdSIJKYgj8ilucp58OiO9KSu0QgtCFf1z2UJTgpB1tEI/tOXlUCVv9uL1nsOc5JKfPxcG87I0QYzZlkIoyLSSapVUcYTQ4Ts6u8ZBy8gkmIg99MH9AYHng4+VkKNGFuql/jdxHeLW8MBfQj7EDgecbaT30I0NVYru2tHCJKXQ2AjjsKO5IjJ5P7KCgZ+BhF3zBxkg5/fuBPdeBilXW3tTK/ucOAWuln/nix4bTiar4LISaXQVY3z1DNswC4xMJbMx0UUjYLmcAkidsgoCXNajo1nM4cjKvDYnW5D85IYWFga1UiJvqucnmZ5l1ky2Eg+Z6SyfY8OzvphW+Ve+OY1qNHh+8o5Av4wOX87qfniUAMDA9v3oXvvMkfkmD3XeSjaLdeTly4Ivhpc4iyHRufOS/Cz4QBOH1tALv7eC1LBrWtdikBMJBgPISxg36JdNz2zvm61sFSKNt4bW0K/bk687ya7W4N7kzUn+Jv66v2Sp4rShlNP26ZzK7eWBwLSxptIKTUUPj8pYfcy6PjEwM7EElivgXYVyB+s0NKar1OMDzbsa4DNopXRcKXgabEjpQTmk2gUcffZXI3IFykDK8TATcpQN5jWnK/EVFof87pO9kcFI4h3dU6g13BKsEBgXy7/PUiJpIJExKCaOUnXGyuh65SIXoBkwFKc8xWTOd6MYBX9R2sfr+QDYiut6//RiaPZ4YE7QslHovUId3dI5cmA5kkUIE60os3mbuX+c3Sgtq/lE5Om8opX8E8RFMX1kYsnI04eFYjuMS3+P29el1rlP0We98EzAYANR041cPm6dJJJrCrNYqXPB66L8TTsY4X7tdWfZPdMpkDyPPDpLHD0PrSugkC7jINQlys7lvekNw=",
  WP_ROOT: 'https://uat-posts.avatarnutrition.com/index.php/wp-json/wp/v2',
  APP_ROOT: 'http://localhost:3000',
  STREAMCHAT: {
    userPrefix: 'local-',
    portalUserPrefix: 'local-avnportal-',
    apiKey: 'cy83mgp8tqpz',
  },
  CDN_ROOT: 'https://cdn.avatarnutrition.com',
 }
 
 const dev = {
   API_ROOT: 'https://dev-api.avatarnutrition.com',
   BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
   FRESHCHAT: 'bb531a73-bcce-4810-afac-6e85213992cb',
   HOME_ROOT: 'http://dev-www.avatarnutrition.com',
   SCANDIT_KEY: "AbSTCxJ+NMdSIJKYgj8ilucp58OiO9KSu0QgtCFf1z2UJTgpB1tEI/tOXlUCVv9uL1nsOc5JKfPxcG87I0QYzZlkIoyLSSapVUcYTQ4Ts6u8ZBy8gkmIg99MH9AYHng4+VkKNGFuql/jdxHeLW8MBfQj7EDgecbaT30I0NVYru2tHCJKXQ2AjjsKO5IjJ5P7KCgZ+BhF3zBxkg5/fuBPdeBilXW3tTK/ucOAWuln/nix4bTiar4LISaXQVY3z1DNswC4xMJbMx0UUjYLmcAkidsgoCXNajo1nM4cjKvDYnW5D85IYWFga1UiJvqucnmZ5l1ky2Eg+Z6SyfY8OzvphW+Ve+OY1qNHh+8o5Av4wOX87qfniUAMDA9v3oXvvMkfkmD3XeSjaLdeTly4Ivhpc4iyHRufOS/Cz4QBOH1tALv7eC1LBrWtdikBMJBgPISxg36JdNz2zvm61sFSKNt4bW0K/bk687ya7W4N7kzUn+Jv66v2Sp4rShlNP26ZzK7eWBwLSxptIKTUUPj8pYfcy6PjEwM7EElivgXYVyB+s0NKar1OMDzbsa4DNopXRcKXgabEjpQTmk2gUcffZXI3IFykDK8TATcpQN5jWnK/EVFof87pO9kcFI4h3dU6g13BKsEBgXy7/PUiJpIJExKCaOUnXGyuh65SIXoBkwFKc8xWTOd6MYBX9R2sfr+QDYiut6//RiaPZ4YE7QslHovUId3dI5cmA5kkUIE60os3mbuX+c3Sgtq/lE5Om8opX8E8RFMX1kYsnI04eFYjuMS3+P29el1rlP0We98EzAYANR041cPm6dJJJrCrNYqXPB66L8TTsY4X7tdWfZPdMpkDyPPDpLHD0PrSugkC7jINQlys7lvekNw=",
   WP_ROOT: 'https://uat-posts.avatarnutrition.com/index.php/wp-json/wp/v2',  
   APP_ROOT: 'https://dev-app.avatarnutrition.com',
   STREAMCHAT: {
    userPrefix: 'dev-',
    portalUserPrefix: 'dev-avnportal-',
    apiKey: 'cy83mgp8tqpz',
  },
  CDN_ROOT: 'https://cdn.avatarnutrition.com',
 }
 
 const uat = {
   API_ROOT: 'https://uat-api.avatarnutrition.com',
   BRAINTREE_DROPIN: 'sandbox_nf2r8r92_jxsf8cf7stpckztc',
   FRESHCHAT: 'bb531a73-bcce-4810-afac-6e85213992cb',
   HOME_ROOT: 'http://uat-www.avatarnutrition.com',
   SCANDIT_KEY: "AbwT1hB+No8xLhGzHTBthC4x3h3gN0BOQXl6q5JlRHaoJzQFRUpGOHREcVp3U+fipl3qXmxrDXaccgz1X0jyGQodlAe8eeXhB2Mao0wHUUBwTnA7jHtG+Hhg2ICaeWoQuixpqN9oZLowXLHz1Fg1+AFcyRFqTLzMgmolOsNFiG+4OHe26CnFTp87L7eiFVIuUTLwF7kMjknMnypsZe9C5V69D0dD4GQAVNseBY78bFNtDBJHlzycpDAbuBM65PevqeDSlVkJSMP61Z1vIoadlqnR52vaTMaysSLvQyOiAs2/nR3TjbKV8cK+qBV+QdIPqMhrSXmfBK5+yXFrukUxz85PNjAaFEutgKRxdVf4qkNn+eQeVJQB2hYpPg63nO/QZomqA3TdLBkn3KmlFREPZv54usE+f/ehpJNUQu/3iQWcm0P7E8igwiMUVhT4s7seh91ApCeSFK5cWSxuhhuzO5ZnT8oqKTm4ekhtJGFpSxYr3sL6lsSyL+dV8WPEmbh45Ip7ouW+T87uX4hGTYG0y5wxcaxylod32Qn/G3nbpwzPvdS8mrzac1KYaSgIUJvXhxSbAldUxmYz5LFjaWi6G1PIvn8ys3+fSnCwk1ftqqzmg+9GIgeN6cDxzlfV1MCaS4BqfZa/nCmSWG0oGd+RYkh6LxXAWvQiMm3sYIMojKE3l4Joi5P2lyoNEULiBHCPgOfvoKIucrW/gpnVNX+kDR4ST7i4SpBvtuXCNpsP9fXaBjXvk0lm8psIUGBIpXezbWNKBIGANUfiaA9LcmZRdbzUF7ALWcMcvcfiCfI9PLfA1qm2ESkcnkwHxxKrc8fonQYMSltcOUEDruCYifZozybV8p63MBFaipcitA0cGurG6pp4VI8=",
   WP_ROOT: 'https://uat-posts.avatarnutrition.com/index.php/wp-json/wp/v2',
   APP_ROOT: 'https://uat-app.avatarnutrition.com',
   STREAMCHAT: {
    userPrefix: 'uat-',
    portalUserPrefix: 'uat-avnportal-',
    apiKey: 'cy83mgp8tqpz',
  },
  CDN_ROOT: 'https://cdn.avatarnutrition.com',
 }
 
 const prod = {
   API_ROOT: 'https://api.avatarnutrition.com',
   BRAINTREE_DROPIN: 'production_7jsf8j4b_tm4gmb6qfhhnby8y',
   FRESHCHAT: 'bb531a73-bcce-4810-afac-6e85213992cb',
   HOME_ROOT: 'https://www.avatarnutrition.com',
   SCANDIT_KEY: "Ae2c5NCBRBgaCFo1dA+WGKcO5+QNGD3Fq0+gWPVDgymNb+FfQV6ygnBUtXQ2Ysk4YXeGaTwgpPDeRlHw8G/NB1lZDf7mfL5hiWtUXIVwFcH5fqOlIEUQASZnNrQ4c/7lEztD2CA/ECZmmRCMTlzJ4M7ZyorAF+g1DnkuFg3tGW+PpIgtQYNXIsKSeoRbZUbKywRCEO3aHjw9YfMaM2yfIpQYSKteiu8W3dTmnsZE5pS22pnp1wqSjhRXFL3RqWAMFhm7ONDvMajB700271K5Hs4JpVomGjDFFoemv1zHmdCRjh8zq4II3uFcysbfVbY+8QkfqQ1dK4286ehJHat2x6j09tWJA5vpO5PBmpazdUUCj59E+gjgfndnZsk3RcNbcucqdOETkAJYufgfyl4Goh+DyZsvNyx7WaOxuPrjF306vlV0cgQko8c8/lcGsErycheM/R79y5mVatONE/k6oHDsJRGgM69YwQQGQ+nrX86kRu1/Yra+Yo8cmyj+jzcwpI7vR86/dAOArD4N9ze9K1kSuw1BlMEOS9L4cn/rRxVzwqAEY1mWEVhbIzg5MHmaKIH04anXIH2ddLnxOqNkQMwNDj6TKJbBjKOWQBYmHs3RUWudNh3LiE1gaUAEFMq0pxiF9QzaWxqX9xybDo6caUKt8V7mtQLShheqb2pYp013DXPKmY1+IRlql/1+fbCXCbS9wGr8JJkb8baGnDD6wtfV1wdzp0RK03D4l53NDdtxOREPejTiT5e8JoEYeHxEkZsTse9Gpcwn47rmZpzBDloa6dXlQxMP1tUsgviqtjxQ5LFBLezfphA=",
   WP_ROOT: 'https://posts.avatarnutrition.com/index.php/wp-json/wp/v2',  
   APP_ROOT: 'https://app.avatarnutrition.com',
   STREAMCHAT: {
    userPrefix: '',
    portalUserPrefix: 'avnportal-',
    apiKey: 'cy83mgp8tqpz',
  },
  CDN_ROOT: 'https://cdn.avatarnutrition.com',
 }

const config = (function(env) {
  switch(env) {
    case 'prod':
        return prod;
    case 'uat': 
        return uat;
    case 'dev': 
        return dev;
    default: 
        return local;
  }
})(process.env.REACT_APP_STAGE)

export default {
  ...config 
}
